import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SupportIssue, SupportIssueDefect } from '../models/SupportIssue';
import { SupportIssueService } from '../services/support-issue.service';
import { NgForm } from '@angular/forms';
import { UserAudit } from 'src/app/users-module/models/userLight';
import { UserService } from 'src/app/users-module/services/user.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-issue-dialog',
  templateUrl: './issue-dialog.component.html',
  styleUrls: ['./issue-dialog.component.less']
})
export class IssueDialogComponent implements OnInit {

  @Input() issue: SupportIssue;
  @Input() descWidth: number;
  @ViewChild('issueForm', {}) ngForm: NgForm;
  public get isQAIssue(): boolean {
    if(this.issue.issueType && this.issue.issueType.issueName == "QA Finding") return true;
    return false;
  }
  public get defectList(): SupportIssueDefect[] {
    if(this.issues.defects && this.issue.issueType) return this.issues.defects.filter(df => df.supportIssueTypeId == this.issue.issueType.id);
    else return [];
  }
  processors: UserAudit[] = [];
  private saving: boolean = false;
  constructor(public modalService: NgbModal, public issues: SupportIssueService, public toast: ToastrService, public usrs: UserService) { }
  ngOnInit() {
    if(!this.descWidth || this.descWidth == 0) {
      this.descWidth = 120;
    }
    this.usrs.FetchUsersForAuditReport().pipe(
      tap((_:UserAudit[]) => {
        this.processors = _;
      },
      err => {
        this.toast.error('Error fetching processors list', 'Error', { closeButton: true, disableTimeOut: true });
      },
      () => {
      })
    ).subscribe();
    this.issues.fetchDefects(13);
  }

  save(): void {
    console.log(this.issue);
    if(!this.saving && this.ngForm.valid) {
      this.saving = true;
      this.issue.supportIssueTypeId = this.issue.issueType.id;
      this.issues.saveIssue(this.issue).subscribe(res => {
        this.saving = false;
      },
      err => this.toast.error('Error saving support issue', '', { closeButton: true, disableTimeOut: true }),
      () => {
        this.toast.success('Support issue submitted.', '');
        this.modalService.dismissAll();
      })
    }
  }

  fetchDefects(): void {
    this.issues.fetchDefects(13);
  }

  cancel(): void {
    this.modalService.dismissAll();
  }

}
